import { useAuth } from '@kitopi-com/customer-auth';
import { useQuery } from '@tanstack/react-query';
import { getSites } from 'api/api';

export const useFetchSites = () => {
  const {
    state: { isSignedIn },
  } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: ['sites'],
    queryFn: () => getSites(),
    enabled: isSignedIn,
  });

  return {
    data,
    isLoading,
    error,
  };
};
